import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { UpdateAnimalDto, IAnimal } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useUpdateAnimal(scope: string = 'updateAnimal') {
  const { userFarm: farmId } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [scope],
    mutationFn: (data: UpdateAnimalDto) => animalController.updateAnimal(farmId!, data),
    onSuccess: (updatedAnimal: IAnimal) => {
      queryClient.invalidateQueries({
        queryKey: ['getAnimalList'],
        exact: false
      })
      queryClient.setQueryData(['getAnimalById', updatedAnimal.id], updatedAnimal)
    }
  })
}
